import React, {FC} from 'react';
import styled from 'styled-components';

import {hoverSelector} from '../../../../../../libs/shared/helpers/src/browser/hoverHelpers';
import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {fontSizes} from '../../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface CellsEmptySetupActionsDismissButtonProps {
  interactionId: string;
  onClick: Handler;
}

/*
 * Style.
 */

const StyledButton = styled(ChromelessButton)`
  grid-area: footer;
  display: flex;
  justify-self: center;
  align-self: center;
`;

const StyledTextDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  ${hoverSelector} {
    color: ${(p) => p.theme.greys.shade80};
  }
  font-size: ${fontSizes.verySmall};
`;

/*
 * Component.
 */

export const CellsEmptySetupActionsDismissButton: FC<CellsEmptySetupActionsDismissButtonProps> = ({
  interactionId,
  onClick,
}) => (
  <StyledButton onClick={onClick} interactionId={interactionId}>
    <StyledTextDiv>
      <Trans id="cells-empty-cta-dismisscopy">Don&#39;t show me again</Trans>
    </StyledTextDiv>
  </StyledButton>
);
